import { Link } from "react-router-dom";
import "./Button.css";

const Button = ({ label, variant, to, href, onClick, type, fullWidth, style: extraStyle }) => {
  const className = `btn btn-${variant || "primary"}`;
  const style = fullWidth ? { width: "100%", ...extraStyle } : extraStyle;

  if (to) {
    return (
      <Link className={className} style={style} to={to}>
        {label}
      </Link>
    );
  }

  if (href) {
    return (
      <a className={className} style={style} href={href}>
        {label}
      </a>
    );
  }

  return (
    <button className={className} style={style} type={type || "button"} onClick={onClick}>
      {label}
    </button>
  );
};

export default Button;
